import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { ArchiveComponent } from './archive.component';
import { SharedModule } from '../shared/shared.module';

const setupRoutes: Routes = [
    {
    path: 'archive',
    component: ArchiveComponent
    }
];

@NgModule({
  declarations: [
    ArchiveComponent, 
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forChild(setupRoutes)
  ],
  bootstrap: [
    ArchiveComponent
  ],
  exports: [
    ArchiveComponent  
  ]
})

export class ArchiveModule {}